import { Upload, X } from "lucide-react";
import CustomInput from "../../shared/CustomInput";
import { useRef } from "react";
import { useError } from "../../context/ErrorProvider";
import { uploadIdentification } from "../../sdk/kyc/kyc";
import { uploadImage } from "../../sdk/upload/upload";
import Loading from "../../shared/Loading";

const AddNationalId = ({
  closeAddNationalId,
  handleNextStep,
  selectedFrontIdFile,
  setSelectedFrontIdFile,
  selectedBackIdFile,
  setSelectedBackIdFile,
  idDetails,
  setIdDetails,
  loading,
}) => {
  const fileInputRef = useRef(null);
  const backFileInputRef = useRef(null);
  const { showError } = useError();

  const handleUploadIdentification = async (file) => {
    try {
      const identificationInfo = await uploadIdentification(file);
      let splitName = identificationInfo?.fullNames?.trim()?.split(" ");
      setIdDetails((prev) => ({
        ...prev,
        firstName: splitName[0] || "",
        middleName: splitName[1] || "",
        lastName: splitName[2] || "",
        identification: identificationInfo?.idNumber || "",
        dateOfBirth:
          formatDate(identificationInfo?.dateOfBirth, "2000-01-01") || "",
        gender: identificationInfo?.sex || "",
      }));
    } catch (error) {
      showError(error?.response?.data?.message || error.message);
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      handleUploadIdentification(file);
      const response = await uploadImage(file);
      setIdDetails((prev) => ({
        ...prev,
        id_front_image: response?.url,
      }));
      setSelectedFrontIdFile(file);
    }
  };
  const handleBackFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const response = await uploadImage(file);
      setIdDetails((prev) => ({
        ...prev,
        id_back_image: response?.url,
      }));
      setSelectedBackIdFile(file);
    }
  };

  function formatDate(dateStr, defaultValue = "") {
    if (typeof dateStr !== "string") return defaultValue;

    const parts = dateStr.split(".");
    if (parts.length !== 3) return defaultValue;

    const [day, month, year] = parts;
    const isValid =
      /^\d{2}$/.test(day) &&
      /^\d{2}$/.test(month) &&
      /^\d{4}$/.test(year) &&
      Number(day) >= 1 &&
      Number(day) <= 31 &&
      Number(month) >= 1 &&
      Number(month) <= 12;

    if (!isValid) return defaultValue;

    return `${year}-${month}-${day}`;
  }

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  const triggerBackFileInput = () => {
    backFileInputRef.current.click();
  };
  return (
    <div
      onClick={(e) => {
        closeAddNationalId();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[850px] h-[600px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeAddNationalId}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div>
          <p className="text-[#000000] font-normal text-[14px]">
            Edit Loan Application
          </p>
          <p className="text-[#000000] font-semibold text-[20px]">
            Add Borrower's National Identification
          </p>
          <p className="text-[#5C5C5C] text-[14px] font-normal">
            You can use their ID to pre-fill their personal information
          </p>
          <div className="flex w-full items-center my-[20px] gap-[20px]">
            <div className="flex w-[45%] flex-col">
              <p className="text-[#222222] font-medium text-[13px]">
                National ID (Front){" "}
                <span className="font-normal text-[#5C5C5C]">
                  .jpeg or .png file only
                </span>
              </p>
              <div
                onClick={triggerFileInput}
                className="h-[90px] flex flex-col justify-center items-center gap-[10px] rounded-[8px] border-[0.7px] border-[#A8A8A8] bg-white cursor-pointer"
              >
                {!selectedFrontIdFile ? (
                  <>
                    <Upload size={24} />
                    <p className="text-[#000000] text-[12px] font-normal text-center">
                      Drag and Drop file here or{" "}
                      <span className="text-[#000000] underline">
                        Choose file
                      </span>{" "}
                      here
                    </p>
                  </>
                ) : (
                  <p className="text-[#000000] text-[12px] font-medium text-center">
                    {selectedFrontIdFile.name} (
                    {(selectedFrontIdFile.size / 1024).toFixed(1)} KB)
                  </p>
                )}
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".jpeg,.png,.pdf,.jpg,.docs"
                  className="hidden"
                  onChange={handleFileChange}
                />
              </div>
            </div>
            <div className="flex w-[45%] flex-col">
              <p className="text-[#222222] font-medium text-[13px]">
                National ID (Back){" "}
                <span className="font-normal text-[#5C5C5C]">
                  .jpeg or .png file only
                </span>
              </p>
              <div
                onClick={triggerBackFileInput}
                className="h-[90px] flex flex-col justify-center items-center gap-[10px] rounded-[8px] border-[0.7px] border-[#A8A8A8] bg-white cursor-pointer"
              >
                {!selectedBackIdFile ? (
                  <>
                    <Upload size={24} />
                    <p className="text-[#000000] text-[12px] font-normal text-center">
                      Drag and Drop file here or{" "}
                      <span className="text-[#000000] underline">
                        Choose file
                      </span>{" "}
                      here
                    </p>
                  </>
                ) : (
                  <p className="text-[#000000] text-[12px] font-medium text-center">
                    {selectedBackIdFile.name} (
                    {(selectedBackIdFile.size / 1024).toFixed(1)} KB)
                  </p>
                )}
                <input
                  ref={backFileInputRef}
                  type="file"
                  accept=".jpeg,.png,.pdf,.jpg,.docs"
                  className="hidden"
                  onChange={handleBackFileChange}
                />
              </div>
            </div>
          </div>
          <div>
            {selectedFrontIdFile && (
              <>
                <div className="flex items-center gap-[20px] my-[10px]">
                  <div className="flex w-[45%] flex-col">
                    <label
                      className="text-[#222222] font-medium text-[13px]"
                      htmlFor="first name"
                    >
                      First Name
                    </label>
                    <CustomInput
                      placeholder="Enter your first name"
                      type="text"
                      value={idDetails?.firstName}
                      onChange={(e) =>
                        setIdDetails({
                          ...idDetails,
                          firstName: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="flex w-[45%] flex-col">
                    <label
                      className="text-[#222222] font-medium text-[13px]"
                      htmlFor="middle name"
                    >
                      Middle Name
                    </label>
                    <CustomInput
                      placeholder="Enter your middle name"
                      type="text"
                      value={idDetails?.middleName}
                      onChange={(e) =>
                        setIdDetails({
                          ...idDetails,
                          middleName: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex items-center gap-[20px] my-[10px]">
                  <div className="flex w-[45%] flex-col">
                    <label
                      className="text-[#222222] font-medium text-[13px]"
                      htmlFor="last-name"
                    >
                      Last Name
                    </label>
                    <CustomInput
                      placeholder="Enter your last name"
                      type="text"
                      value={idDetails?.lastName}
                      onChange={(e) =>
                        setIdDetails({
                          ...idDetails,
                          lastName: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="flex w-[45%] flex-col">
                    <label
                      className="text-[#222222] font-medium text-[13px]"
                      htmlFor="date of birth"
                    >
                      Date of Birth
                    </label>
                    <CustomInput
                      placeholder="Enter your birth date"
                      type="text"
                      value={idDetails?.dateOfBirth}
                      onChange={(e) =>
                        setIdDetails({
                          ...idDetails,
                          dateOfBirth: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex items-center gap-[20px] my-[10px]">
                  <div className="flex w-[45%] flex-col">
                    <label
                      className="text-[#222222] font-medium text-[13px]"
                      htmlFor="gender"
                    >
                      Gender
                    </label>
                    <CustomInput
                      name="gender"
                      placeholder="Enter your gender"
                      value={idDetails?.gender}
                      onChange={(e) =>
                        setIdDetails({
                          ...idDetails,
                          gender: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="absolute bottom-[10px] w-full px-[20px] left-0 flex items-center gap-[10px] justify-end">
          <button
            onClick={closeAddNationalId}
            className="bg-[#F3F3F3] h-[35px] px-[20px] rounded-[30px] text-[#5C5C5C] font-medium text-[15px]"
          >
            Close
          </button>
          <button
            onClick={handleNextStep}
            disabled={loading}
            className="h-[35px] bg-[#000000] rounded-[30px] flex items-center justify-center gap-[5px] px-[15px] text-[15px] font-bold text-white"
          >
            {loading && <Loading />}
            Add ID
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNationalId;
